import { typographiesInterface } from "./typographies_interface";

export const Heading0 = ({ className, text }: typographiesInterface) => (
  <h1 className={`${className} heading-0-style`}>{text}</h1>
);
export const Heading1 = ({ className, text }: typographiesInterface) => (
  <h1 className={`${className} heading-1-style`}>{text}</h1>
);
export const Heading1Mode = ({
  className = "",
  text,
  isDarkMode,
}: typographiesInterface) => {
  const headingStyle = isDarkMode
    ? "text-white  heading-1-style"
    : "text-slate-600  heading-1-style";

  return <h1 className={`${className} ${headingStyle}`}>{text}</h1>;
};
export const Heading2 = ({ className, text }: typographiesInterface) => (
  <h2 className={`${className} heading-2-style`}>{text}</h2>
);
export const Heading2Md = ({ className, text }: typographiesInterface) => (
  <h2 className={`${className} heading-2-md-style`}>{text}</h2>
);
export const Heading2Sm = ({ className, text }: typographiesInterface) => (
  <h2 className={`${className} heading-2-sm-style`}>{text}</h2>
);
export const Heading3 = ({ className, text }: typographiesInterface) => (
  <h3 className={`${className} heading-3-style`}>{text}</h3>
);
export const Heading3Md = ({ className, text }: typographiesInterface) => (
  <h3 className={`${className} heading-3-md-style`}>{text}</h3>
);

export const Heading3Sm = ({ className, text }: typographiesInterface) => (
  <h3 className={`${className} heading-3-sm-style`}>{text}</h3>
);

export const Heading4 = ({ className, text }: typographiesInterface) => (
  <h4 className={`${className} heading-4-style `}>{text}</h4>
);

export const Heading5 = ({ className, text }: typographiesInterface) => (
  <h5 className={`${className} heading-5-style`}>{text}</h5>
);

export const Heading6 = ({ className, text }: typographiesInterface) => (
  <h4 className={`${className} heading-6-style`}>{text}</h4>
);
